/**
 * EDI-SIG Frontend Authenticated API Fetch Wrapper Module
 */
import { API_BASE, showToast } from './config.js';
import { Auth } from './auth.js';

function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('edi_sig_token');
  const csrfToken = getCookie('edi_sig_csrf') || localStorage.getItem('edi_sig_csrf');

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    ...(options.headers || {})
  };

  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      ...options,
      credentials: 'same-origin',
      headers
    });

    if (response.status === 401) {
      Auth.logout();
      throw new Error('Session expired. Please log in again.');
    }

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error || `HTTP error ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.error(`API Error [${endpoint}]:`, err.message);
    throw err;
  }
}
